import { fetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import { collectionObjectApiPath, normalizeCollectionObjectMeta } from '@/utils/collection-object'

export default function useCollection(collection_slug: string) {
	const key = collection_slug ? `${API_URL}/${collectionObjectApiPath(collection_slug)}` : null
	return useSwr(key, async (url: string) => normalizeCollectionObjectMeta(await fetcher(url), collection_slug))
}
